import React from 'react'
import LeftBar from '../../Components/LeftBar'
import Dashnav from '../../Components/Dashnav'
import IntakesComp from './IntakesComp'

function Intakes() {
  return (
    <div className='mainContainer'>
      <LeftBar/>
      <div className='theMainContainer'>
          <Dashnav/>
          <IntakesComp/>      
      </div>
  </div>

  )
}

export default Intakes